import common from './common';

export function translate(key, l = null) {
	let str = key || '';
	if (str.length > 0) {
		const split = str.split('.');
		split.push(l || common.config.language || 'en');
		let i; let length; let t = common.config.strings;
		for (i = 0, length = split.length; i < length; ++i) {
			t = t[split[i]];
			if (!t) break;
		}
		i === split.length && (str = t);
	}
	return str;
}

export function Text(text, params) {
	if (common.config.language === 'ar') {
		let t = new PIXI.Text(text, {fontSize: params.fontSize, fontFamily: 'Tahoma, Geneva, sans-serif', align: params.align, fill: params.colour, padding: 5});
		t.resolution = 2;
		return t;
	} else {
		let t = new PIXI.extras.BitmapText(text, {font: `${params.fontSize}px ${params.fontFamily}`, align: params.align});
		t.tint = params.colour;
		return t;
	}
}
